// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
const ADDRESS_SEARCH_REQUEST = 'ADDRESS_SEARCH_REQUEST';
const ADDRESS_SEARCH_REQUEST_SUCCESS = 'ADDRESS_SEARCH_REQUEST_SUCCESS';
const ADDRESS_SEARCH_REQUEST_FAILED = 'ADDRESS_SEARCH_REQUEST_FAILED';

const SELECTED_ADDRESS_REQUEST = 'SELECTED_ADDRESS_REQUEST';
const SELECTED_ADDRESS_REQUEST_SUCCESS = 'SELECTED_ADDRESS_REQUEST_SUCCESS';
const SELECTED_ADDRESS_REQUEST_FAILED = 'SELECTED_ADDRESS_REQUEST_FAILED';

const ADDRESS_SEARCH_FIELD_CHANGE = 'ADDRESS_SEARCH_FIELD_CHANGE';

const ADDRESS_RESET_SEARCH_INPUT = 'ADDRESS_RESET_SEARCH_INPUT';

export {
  ADDRESS_SEARCH_REQUEST,
  ADDRESS_SEARCH_REQUEST_SUCCESS,
  ADDRESS_SEARCH_REQUEST_FAILED,

  SELECTED_ADDRESS_REQUEST,
  SELECTED_ADDRESS_REQUEST_SUCCESS,
  SELECTED_ADDRESS_REQUEST_FAILED,

  ADDRESS_SEARCH_FIELD_CHANGE,

  ADDRESS_RESET_SEARCH_INPUT,
};
